var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Обёртка над браузерным хранилищем, которая никогда не бросает исключений.
 * Хранилище бывает недоступно: в некоторых WebView window.localStorage === null, при отключённых cookies
 * само обращение к нему бросает SecurityError, при переполнении бросает setItem(). В этих случаях данные
 * хранятся в памяти до перезагрузки страницы.
 */
var SafeStorage = /** @class */ (function () {
    function SafeStorage(storage) {
        this.storage = storage;
        this.memory = new Map();
    }
    Object.defineProperty(SafeStorage.prototype, "length", {
        get: function () {
            var _this = this;
            return this.call(function (storage) { return storage.length; }, function () { return _this.memory.size; });
        },
        enumerable: false,
        configurable: true
    });
    SafeStorage.prototype.key = function (index) {
        var _this = this;
        return this.call(function (storage) { return storage.key(index); }, function () { var _a; return (_a = __spreadArray([], __read(_this.memory.keys()), false)[index]) !== null && _a !== void 0 ? _a : null; });
    };
    SafeStorage.prototype.getItem = function (key) {
        var _this = this;
        return this.call(function (storage) { return storage.getItem(key); }, function () { var _a; return (_a = _this.memory.get(key)) !== null && _a !== void 0 ? _a : null; });
    };
    SafeStorage.prototype.setItem = function (key, value) {
        var _this = this;
        this.call(function (storage) { return storage.setItem(key, value); }, function () { return void _this.memory.set(key, String(value)); });
    };
    SafeStorage.prototype.removeItem = function (key) {
        var _this = this;
        this.call(function (storage) { return storage.removeItem(key); }, function () { return void _this.memory.delete(key); });
    };
    SafeStorage.prototype.clear = function () {
        var _this = this;
        this.call(function (storage) { return storage.clear(); }, function () { return _this.memory.clear(); });
    };
    SafeStorage.prototype.call = function (action, fallback) {
        if (this.storage) {
            try {
                return action(this.storage);
            }
            catch (_a) {
                // хранилище недоступно или переполнено — работаем с памятью
            }
        }
        return fallback();
    };
    return SafeStorage;
}());
var instances = {};
function getNativeStorage(type) {
    var _a;
    try {
        return (_a = window[type]) !== null && _a !== void 0 ? _a : null;
    }
    catch (_b) {
        return null;
    }
}
function getStorage(type) {
    var _a;
    return (_a = instances[type]) !== null && _a !== void 0 ? _a : (instances[type] = new SafeStorage(getNativeStorage(type)));
}
export function getLocalStorage() {
    return getStorage('localStorage');
}
export function getSessionStorage() {
    return getStorage('sessionStorage');
}
